import { Button, Icon } from '@deque/cauldron-react';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './StepReview.css';

export type StepReviewProps = {
  title: string;
  fields: {
    name: string;
    value: string;
  }[];
  onEdit: () => void;
};

const StepReview: FC<StepReviewProps> = ({ title, fields, onEdit }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.reviewSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.title}>{title}</h2>
        <Button
          onClick={onEdit}
          variant="secondary"
          thin
          aria-label={t('Edit {{ title }}', { title })}
        >
          <Icon type="pencil" className={styles.buttonIcon} />
          {t('Edit')}
        </Button>
      </div>
      <div className={styles.content}>
        {fields.some(({ name, value }) => name && value) && (
          <dl className={styles.descriptionList}>
            {fields.map(
              ({ name, value }, index) =>
                name &&
                value && (
                  <React.Fragment key={index}>
                    <dt className={styles.fieldName}>{name}</dt>
                    <dd className={styles.fieldValue}>{value}</dd>
                  </React.Fragment>
                )
            )}
          </dl>
        )}
      </div>
    </div>
  );
};

export default StepReview;
